import Luiv3Constants from '@app/lui3/constants';
import styled from 'styled-components';

export const Header = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
`;

export const Loading = styled.div`
  border-radius: 1.5rem;
  box-shadow: 0 0.4375rem 1.75rem 0 rgba(3, 6, 12, 0.24);
  width: 100%;
  max-width: 600px;
  padding: clamp(1rem, 6vw, 3rem);
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 12rem;
`;

export const LinksContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1rem;
`;

export const ErrorMessage = styled.div`
  color: ${Luiv3Constants.baseColor['red-600']};
  font-size: 0.875rem;
  line-height: 1.25rem;
`;
